<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <InfractionTypeForm />
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import InfractionTypeForm from "@/components/settings/frota/infractions-types/InfractionTypeForm.vue";

export default {
  name: "InfractionTypeAdd",
  components: {
    PageTitle,
    PageRowWrapper,
    InfractionTypeForm,
  },
};
</script>
